import React from 'react';
import styled, { css } from 'styled-components';
import KeywordInput from '../../atoms/KeywordInput';
import SearchAreaInput, {
  SEARCH_AREA_INPUT_OPTIONS,
} from '../../atoms/SearchAreaInput';
import SearchForm from '../../atoms/SearchForm';
import useVerticalSearchBarLogic from './useVerticalSearchBarLogic';

const MOBILE_SEARCH_BAR_CONSTS = {
  INPUT_SIZE: SEARCH_AREA_INPUT_OPTIONS.SIZES.LG,
};

const allInputStyles = css`
  padding: ${props => props.theme.padding.small} 0;
`;

const StyledSearchAreaInput = styled(SearchAreaInput)`
  ${allInputStyles}

  /** IS SEARCH AREA INPUT FOCUSED? */
  border-bottom: 1px solid
    ${props =>
      props.isSearchAreaInputFocused
        ? props.theme.primary.normal
        : props.theme.text.text200};
`;

const StyledKeywordInput = styled(KeywordInput)`
  ${allInputStyles}
`;

// Required so form submits on mobile in all browsers.
// Refer https://stackoverflow.com/questions/52236168/cant-submit-form-using-enter-in-safari-browser
const StyledHiddenButton = styled.button`
  visibility: hidden;
  width: 0;
  height: 0;
  overflow: hidden;
`;

const VerticalSearchBar = () => {
  const { isSearchAreaInputFocused } = useVerticalSearchBarLogic();
  return (
    <SearchForm>
      <StyledHiddenButton type="submit" />
      <StyledSearchAreaInput
        isSearchAreaInputFocused={isSearchAreaInputFocused}
        size={MOBILE_SEARCH_BAR_CONSTS.INPUT_SIZE}
      />
      <StyledKeywordInput size={MOBILE_SEARCH_BAR_CONSTS.INPUT_SIZE} />
    </SearchForm>
  );
};

export default VerticalSearchBar;
